var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isCustom
    ? _c("img", {
        staticClass: "BaseIcon",
        class: "BaseIcon__size-" + _vm.size,
        style: _vm.style,
        attrs: { src: _vm.src },
        on: {
          click: function($event) {
            _vm.$emit("click", $event)
          }
        }
      })
    : _c(
        "v-icon",
        _vm._g(
          _vm._b({ staticClass: "BaseIcon" }, "v-icon", _vm.$attrs, false),
          _vm.$listeners
        ),
        [_vm._t("default")],
        2
      )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44740c59", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44740c59","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/webapp/components/BaseIcon.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-44740c59","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/webapp/components/BaseIcon.vue
// module chunks = 0 1 2 3